import initialState from './messages.initialState';
import { ADD_MESSAGE, DISMISS_MESSAGE } from './messages.actions';

export default function errorsReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      return [...state, action.message];

    case DISMISS_MESSAGE:
      return state.slice(1);

    default:
      return state;
  }
}
